<script>
  import { Bar } from 'vue-chartjs'
  import VueCharts from 'vue-chartjs'


  export default {
    extends: Bar,
    mixins: [VueCharts.mixins.reactiveProp],
    prop: ['chartData', 'max', 'size'],
    data: () => ({
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              stepSize: Math.ceil(this.max / 3),
              maxTicksLimit: 5,
              max: this.max === 0 ? 3 : this.max,
              beginAtZero: true,
              min: 0
            },
            scaleLabel: {
              display: true,
              labelString: "No. of Leads",
              position: 'top'
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: "Days of the Event",
            }
          }]
        },
        legend: {
          display: true,
          position: 'bottom'
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 10,
            bottom: 0
          }
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      }
    }),
    mounted () {
      // Overwriting base render method with actual data.
      this.renderChart(this.chartData, this.options);
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/a_generalDashboard/Card4.vue